// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-qr-code-view .qrcode-text-container {
  padding: 4px 0;
}
.fi-qr-code-view .qrcode-text-container .qrcode-text {
  line-height: 36px;
}
.fi-qr-code-view qrcode {
  display: block;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-qr-code-view/qr-code-view.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;AAAR;AAEQ;EACI,iBAAA;AAAZ;AAII;EACI,cAAA;EACA,mBAAA;AAFR","sourcesContent":[".fi-qr-code-view {\r\n    .qrcode-text-container {\r\n        padding: 4px 0;\r\n\r\n        .qrcode-text {\r\n            line-height: 36px;\r\n        }\r\n    }\r\n\r\n    qrcode {\r\n        display: block;\r\n        margin-bottom: 10px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
